import React from 'react';
import { Search, Filter } from 'lucide-react';

const ProduitServiceFilters = ({ filters, onFilterChange }) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Recherche */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Rechercher..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        {/* Filtre par catégorie */}
        <div>
          <input
            type="text"
            placeholder="Catégorie"
            value={filters.categorie}
            onChange={(e) => onFilterChange('categorie', e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        {/* Filtre par statut */}
        <div>
          <select
            value={filters.is_active}
            onChange={(e) => onFilterChange('is_active', e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="">Tous les statuts</option>
            <option value="true">Actifs</option>
            <option value="false">Inactifs</option>
          </select>
        </div>

        {/* Tri */}
        <div>
          <select
            value={filters.ordering}
            onChange={(e) => onFilterChange('ordering', e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="-created_at">Plus récents</option>
            <option value="created_at">Plus anciens</option>
            <option value="name">Nom (A-Z)</option>
            <option value="-name">Nom (Z-A)</option>
            <option value="price">Prix croissant</option>
            <option value="-price">Prix décroissant</option>
          </select>
        </div>
      </div>

      {/* Filtres de prix */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Prix minimum
          </label>
          <input
            type="number"
            placeholder="0.00"
            value={filters.prix_min}
            onChange={(e) => onFilterChange('prix_min', e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Prix maximum
          </label>
          <input
            type="number"
            placeholder="0.00"
            value={filters.prix_max}
            onChange={(e) => onFilterChange('prix_max', e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>
      </div>
    </div>
  );
};

export default ProduitServiceFilters;
